<button
  type="button"
  class="app-icon-button"
  [class.variant-filled]="variant === 'filled'"
  [class.variant-tonal]="variant === 'tonal'"
  [class.variant-outline]="variant === 'outline'"
  [class.size-sm]="size === 'sm'"
  [class.size-md]="size === 'md'"
  [class.size-lg]="size === 'lg'"
  [attr.aria-label]="ariaLabel || icon"
  [disabled]="disabled"
  (pointerdown)="onPointerDown($event)"
  (click)="clicked.emit($event)">
  <span class="state-layer" aria-hidden="true"></span>
  <app-icon [name]="icon" [color]="color" [size]="size"></app-icon>
</button>
